module.exports = __webpack_public_path__ + "static/media/easy-survey.fb981ed5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/easy-survey.png
// module id = 1179
// module chunks = 0